import { Link } from 'react-router-dom';
import '../index.css';

const Credits = () => {
  const pricingData = [
    { credits: 20, price: 'R$ 19,90', whatsapp: 'Olá! Quero comprar o pacote de 20 créditos por R$ 19,90' },
    { credits: 40, price: 'R$ 39,90', whatsapp: 'Olá! Quero comprar o pacote de 40 créditos por R$ 39,90' },
    { credits: 60, price: 'R$ 49,90', whatsapp: 'Olá! Quero comprar o pacote de 60 créditos por R$ 49,90' },
    { credits: 100, price: 'R$ 59,90', whatsapp: 'Olá! Quero comprar o pacote de 100 créditos por R$ 59,90' },
    { credits: 200, price: 'R$ 119,80', whatsapp: 'Olá! Quero comprar o pacote de 200 créditos por R$ 119,80' },
    { credits: 300, price: 'R$ 179,70', whatsapp: 'Olá! Quero comprar o pacote de 300 créditos por R$ 179,70' },
    { credits: 400, price: 'R$ 239,60', whatsapp: 'Olá! Quero comprar o pacote de 400 créditos por R$ 239,60' },
  ];

  const packages = [
    { name: 'MINI', credits: 20, price: 'R$ 19,90', color: 'linear-gradient(135deg, #4f46e5, #6366f1)', whatsapp: 'Olá! Quero comprar o pacote Mini de 20 créditos por R$ 19,90' },
    { name: 'BÁSICO', credits: 40, price: 'R$ 39,90', color: 'linear-gradient(135deg, #0891b2, #0e7490)', whatsapp: 'Olá! Quero comprar o pacote Básico de 40 créditos por R$ 39,90' },
    { name: 'MÉDIO', credits: 60, price: 'R$ 49,90', color: 'linear-gradient(135deg, #059669, #047857)', whatsapp: 'Olá! Quero comprar o pacote Médio de 60 créditos por R$ 49,90' },
    { name: 'INICIANTE', credits: 100, price: 'R$ 59,90', color: 'linear-gradient(135deg, #7c3aed, #8b5cf6)', whatsapp: 'Olá! Quero comprar o pacote Iniciante de 100 créditos por R$ 59,90' },
    { name: 'POPULAR', credits: 200, price: 'R$ 119,80', color: 'linear-gradient(135deg, #0ea5e9, #0284c7)', whatsapp: 'Olá! Quero comprar o pacote Popular de 200 créditos por R$ 119,80' },
    { name: 'AVANÇADO', credits: 300, price: 'R$ 179,70', color: 'linear-gradient(135deg, #0d9488, #0f766e)', whatsapp: 'Olá! Quero comprar o pacote Avançado de 300 créditos por R$ 179,70' },
    { name: 'PREMIUM', credits: 400, price: 'R$ 239,60', color: 'linear-gradient(135deg, #ea580c, #c2410c)', featured: true, whatsapp: 'Olá! Quero comprar o pacote Premium de 400 créditos por R$ 239,60' },
  ];

  const testimonials = [
    'https://static.lumi.new/56/56199ce0a3c4305887791d0e8dff67f5.webp',
    'https://static.lumi.new/3b/3b544e53ba60a28ba8e9c7e25f96d6c9.webp',
    'https://static.lumi.new/bb/bbc9550153f96b18181b1f39c9a2cef4.webp',
    'https://static.lumi.new/1b/1b0577f3a27dddc5f8fc80c4d1b027e9.webp',
    'https://static.lumi.new/21/21ba690eb33c9452fd1421f835c99f19.webp',
    'https://static.lumi.new/f5/f599264fcb47b6f92f449d9be4c950b5.webp',
    'https://static.lumi.new/78/781ee494cd07d941e5e4f724d1d25215.webp',
    'https://static.lumi.new/9a/9ad1b66be083335a3c0ceaff4c84a84f.webp',
    'https://static.lumi.new/6f/6ff476de0ba4fa13ec9b5decacf11946.webp',
    'https://static.lumi.new/34/34f4a67efacee884a23efb415e9e1f24.webp',
    'https://static.lumi.new/71/711701e834145f837026ff7b292842d3.webp',
    'https://static.lumi.new/8b/8b0f5859c7f8edf4c039109d1d41acb9.webp',
    'https://static.lumi.new/b5/b5542e52fac3af71b241670f2ff4eac9.webp',
    'https://static.lumi.new/79/79715d0261300ce4b6131318158dad4d.webp',
  ];

  const faqItems = [
    {
      question: 'Quanto tempo leva para os créditos aparecerem na minha conta?',
      answer: 'O tempo para os créditos caírem na sua conta depende da demanda do momento. Se tiver muitas pessoas na fila, pode demorar um pouco mais, mas no geral é de 10 a 20 minutos para cair na conta. Todos os créditos são entregues com 100% de garantia!'
    },
    {
      question: 'É o método de workspace ou os créditos caem direto na minha conta?',
      answer: 'Não, não é workspace. Você manda seu link de convite e os créditos caem direto na sua conta.'
    },
    {
      question: 'Serve para contas antigas e contas free?',
      answer: 'Sim! Serve para todas as contas Lovable, sejam antigas ou free.'
    },
    {
      question: 'É seguro compartilhar meu Invite Link?',
      answer: 'Sim, é totalmente seguro! O Invite Link é a forma oficial do Lovable para adicionar créditos. Você compartilha apenas o link de convite, nunca sua senha ou dados sensíveis da conta.'
    },
    {
      question: 'Quais formas de pagamento são aceitas?',
      answer: 'Aceitamos PIX (confirmação instantânea), cartões de crédito (Visa, Mastercard, Elo) e outras formas de pagamento digital. O PIX é a forma mais rápida para receber seus créditos.'
    },
    {
      question: 'E se eu não receber os créditos?',
      answer: 'Oferecemos garantia total! Se houver qualquer problema com a entrega dos créditos, você tem até 7 dias para solicitar reembolso completo ou reenvio. Entre em contato via WhatsApp e resolveremos imediatamente.'
    },
    {
      question: 'Os créditos expiram?',
      answer: 'Até a data de hoje, os créditos bônus de indicação adicionados à sua conta Lovable não têm prazo de validade. Porém, o Lovable pode alterar essa política a qualquer momento. Recomendamos usar seus créditos assim que receber para aproveitar ao máximo!'
    },
    {
      question: 'Posso comprar mais de um pacote?',
      answer: 'Sim! Você pode comprar quantos pacotes quiser. Quanto mais você comprar, mais economia terá!'
    }
  ];

  const whatsappBase = 'https://wa.me/5511964768245?text=';

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'hsl(217, 33%, 17%)', 
      color: 'hsl(210, 40%, 98%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: 1.6
    }}>
      {/* Promo Banner */}
      <div style={{
        background: 'linear-gradient(135deg, hsl(0, 84%, 60%), hsl(0, 84%, 50%))',
        textAlign: 'center',
        padding: '12px 16px',
        fontWeight: 'bold',
        fontSize: 17,
        animation: 'pulse 2s infinite'
      }}>
        🔥 MELHORES PREÇOS DO MERCADO! 🔥
      </div>

      {/* Imagem de Destaque */}
      <div style={{
        background: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0'
      }}>
        <img
          src="https://static.lumi.new/20/2060299bbd3e43532341649d9d9976c5.webp"
          alt="Lovable Créditos"
          style={{
            width: '100%',
            maxWidth: 600,
            height: 'auto',
            display: 'block'
          }}
        />
      </div>

      {/* Voltar */}
      <div style={{ padding: '16px 16px 0', maxWidth: 1200, margin: '0 auto' }}>
        <Link to="/produtos" style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: 14,
          fontWeight: 500
        }}>
          ← Voltar para Produtos
        </Link>
      </div>

      {/* Fluxo Visual - Como Comprar */}
      <section style={{
        padding: '56px 16px 64px',
        background: 'linear-gradient(180deg, hsl(217, 33%, 17%), hsl(220, 35%, 14%))'
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(26px, 5vw, 38px)',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: 8,
            letterSpacing: '-0.02em'
          }}>
            🛒 COMO COMPRAR SEUS CRÉDITOS?
          </h2>
          <p style={{ textAlign: 'center', fontSize: 16, color: 'hsl(215, 20%, 65%)', marginBottom: 48, maxWidth: 600, margin: '0 auto 48px' }}>
            Processo simples, rápido e 100% seguro
          </p>

          {/* Fluxo Desktop */}
          <div className="flow-desktop" style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: 0,
            flexWrap: 'wrap'
          }}>
            {[
              { step: '1', icon: '📦', title: 'Escolha o Pacote', desc: 'Selecione a quantidade de créditos desejada na tabela abaixo', color: '#7c3aed' },
              { step: '2', icon: '💬', title: 'Fale no WhatsApp', desc: 'Entre em contato conosco pelo WhatsApp para iniciar', color: '#22c55e' },
              { step: '3', icon: '💳', title: 'Faça o Pagamento', desc: 'Pague via PIX, cartão ou transferência bancária', color: '#0ea5e9' },
              { step: '4', icon: '🔗', title: 'Envie seu Link', desc: 'Compartilhe seu link de convite Lovable (invite link)', color: '#f59e0b' },
              { step: '5', icon: '✅', title: 'Receba os Créditos!', desc: 'Em poucos minutos os créditos caem direto na sua conta', color: '#10b981' }
            ].map((item, i, arr) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start' }}>
                {/* Card do passo */}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  width: 150,
                  position: 'relative'
                }}>
                  {/* Número + Ícone */}
                  <div style={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    background: `linear-gradient(135deg, ${item.color}, ${item.color}cc)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 32,
                    marginBottom: 14,
                    boxShadow: `0 8px 24px ${item.color}44`,
                    position: 'relative',
                    border: '3px solid rgba(255,255,255,0.15)'
                  }}>
                    {item.icon}
                    <span style={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      background: '#fff',
                      color: item.color,
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      fontSize: 13,
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                    }}>
                      {item.step}
                    </span>
                  </div>
                  <p style={{ fontSize: 15, fontWeight: 'bold', marginBottom: 6, color: '#fff', lineHeight: 1.3 }}>{item.title}</p>
                  <p style={{ fontSize: 12.5, color: 'hsl(215, 20%, 65%)', lineHeight: 1.5, margin: 0, padding: '0 4px' }}>{item.desc}</p>
                </div>

                {/* Seta entre passos */}
                {i < arr.length - 1 && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 72,
                    padding: '0 6px',
                    flexShrink: 0
                  }}>
                    <svg width="32" height="20" viewBox="0 0 32 20" fill="none" style={{ opacity: 0.5 }}>
                      <path d="M0 10H26M26 10L18 2M26 10L18 18" stroke="#8b5cf6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Versão Mobile - Vertical */}
          <style>{`
            @media (min-width: 769px) {
              .flow-mobile { display: none !important; }
              .flow-desktop { display: flex !important; }
            }
            @media (max-width: 768px) {
              .flow-mobile { display: flex !important; }
              .flow-desktop { display: none !important; }
            }
          `}</style>

          <div className="flow-mobile" style={{
            display: 'none',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0
          }}>
            {[
              { step: '1', icon: '📦', title: 'Escolha o Pacote', desc: 'Selecione a quantidade de créditos desejada', color: '#7c3aed' },
              { step: '2', icon: '💬', title: 'Fale no WhatsApp', desc: 'Entre em contato conosco pelo WhatsApp', color: '#22c55e' },
              { step: '3', icon: '💳', title: 'Faça o Pagamento', desc: 'Pague via PIX, cartão ou transferência', color: '#0ea5e9' },
              { step: '4', icon: '🔗', title: 'Envie seu Invite Link', desc: 'Compartilhe seu link de convite Lovable', color: '#f59e0b' },
              { step: '5', icon: '✅', title: 'Receba os Créditos!', desc: 'Em poucos minutos caem direto na sua conta', color: '#10b981' }
            ].map((item, i, arr) => (
              <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 18,
                  background: 'hsl(217, 33%, 20%)',
                  borderRadius: 16,
                  padding: '18px 24px',
                  border: `2px solid ${item.color}44`,
                  width: '100%',
                  maxWidth: 380
                }}>
                  <div style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    background: `linear-gradient(135deg, ${item.color}, ${item.color}cc)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 26,
                    flexShrink: 0,
                    position: 'relative',
                    border: '2px solid rgba(255,255,255,0.1)'
                  }}>
                    {item.icon}
                    <span style={{
                      position: 'absolute',
                      top: -5,
                      right: -5,
                      background: '#fff',
                      color: item.color,
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      fontSize: 11,
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {item.step}
                    </span>
                  </div>
                  <div>
                    <p style={{ fontSize: 15, fontWeight: 'bold', marginBottom: 3, color: '#fff' }}>{item.title}</p>
                    <p style={{ fontSize: 13, color: 'hsl(215, 20%, 65%)', margin: 0, lineHeight: 1.4 }}>{item.desc}</p>
                  </div>
                </div>
                {/* Seta vertical */}
                {i < arr.length - 1 && (
                  <div style={{ padding: '6px 0', display: 'flex', justifyContent: 'center' }}>
                    <svg width="20" height="28" viewBox="0 0 20 28" fill="none">
                      <path d="M10 0V22M10 22L3 15M10 22L17 15" stroke="#8b5cf6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>


        </div>
      </section>

      {/* Como Funciona */}
      <section style={{ padding: '64px 16px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 12 }}>
            🛒 COMO FUNCIONA A COMPRA?
          </h2>
          <p style={{ textAlign: 'center', fontSize: 17, color: 'hsl(215, 20%, 75%)', marginBottom: 36, maxWidth: 700, margin: '0 auto 36px' }}>
            Comprar créditos Lovable é simples: escolha a quantidade desejada no nosso simulador de preços, informe seu link de convite Lovable (invite link) e finalize o pagamento via PIX ou cartão de crédito. Os créditos são adicionados diretamente na sua conta Lovable em poucos minutos.
          </p>
          <div style={{
            background: 'rgba(34, 197, 94, 0.08)',
            border: '2px solid rgba(34, 197, 94, 0.25)',
            borderRadius: 14,
            padding: '20px 28px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            maxWidth: 700,
            margin: '0 auto'
          }}>
            <span style={{ fontSize: 28, flexShrink: 0 }}>🔒</span>
            <p style={{ fontSize: 15, color: 'hsl(215, 20%, 85%)', lineHeight: 1.7, margin: 0 }}>
              <strong style={{ color: 'hsl(142, 71%, 55%)' }}>Segurança total:</strong> Não é necessário compartilhar senha — usamos apenas o link de indicação oficial da plataforma Lovable.
            </p>
          </div>
        </div>
      </section>

      {/* Vantagens */}
      <section style={{ padding: '48px 16px 64px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(26px, 5vw, 36px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 36 }}>
            ✨ VANTAGENS DE COMPRAR CONOSCO
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 20
          }}>
            {[
              { icon: '⚡', title: 'Entrega Instantânea', desc: 'Créditos na sua conta em minutos após o pagamento via PIX' },
              { icon: '💰', title: 'Até 30% de Desconto', desc: 'Economize em relação ao preço oficial da Lovable' },
              { icon: '🇧🇷', title: 'Pagamento via PIX', desc: 'Sem burocracia, sem cartão internacional' },
              { icon: '💬', title: 'Suporte 24/7', desc: 'Atendimento humano pelo WhatsApp' },
              { icon: '⭐', title: '+500 Clientes Satisfeitos', desc: 'Avaliação média de 4.9/5' },
              { icon: '♾️', title: 'Créditos Não Expiram', desc: 'Use quando quiser, sem prazo de validade' }
            ].map((item, i) => (
              <div key={i} style={{
                background: 'hsl(217, 33%, 20%)',
                padding: '24px 26px',
                borderRadius: 14,
                border: '1px solid rgba(139,92,246,0.2)',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 14,
                transition: 'all 0.3s'
              }}>
                <span style={{ fontSize: 28, lineHeight: 1, flexShrink: 0 }}>{item.icon}</span>
                <div>
                  <p style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 4, color: '#fff' }}>{item.title}</p>
                  <p style={{ fontSize: 14, color: 'hsl(215, 20%, 70%)', margin: 0, lineHeight: 1.5 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tabela de Preços */}
      <section style={{ padding: '64px 16px' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 32 }}>
            📊 TABELA DE PREÇOS
          </h2>
          <div style={{
            background: 'linear-gradient(135deg, hsl(217, 33%, 17%), hsl(217, 33%, 20%))',
            borderRadius: 16,
            overflow: 'hidden',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 500 }}>
                <thead>
                  <tr style={{ background: 'linear-gradient(90deg, hsl(217, 33%, 22%), hsl(60, 30%, 30%))' }}>
                    <th style={{ padding: 20, textAlign: 'left', fontWeight: 'bold', fontSize: 17, borderBottom: '2px solid rgba(139,92,246,0.2)' }}>Pacote de Créditos</th>
                    <th style={{ padding: 20, textAlign: 'left', fontWeight: 'bold', fontSize: 17, borderBottom: '2px solid rgba(139,92,246,0.2)' }}>Preço</th>
                  </tr>
                </thead>
                <tbody>
                  {pricingData.map((row, i) => (
                    <tr key={i} style={{
                      borderBottom: '1px solid rgba(139,92,246,0.1)',
                      background: i % 2 === 0
                        ? 'linear-gradient(90deg, hsl(263, 40%, 25%), hsl(263, 40%, 35%))'
                        : 'linear-gradient(90deg, hsl(217, 33%, 20%), hsl(263, 40%, 30%))',
                      transition: 'all 0.3s'
                    }}>
                      <td style={{ padding: 20 }}>{row.credits} Créditos</td>
                      <td style={{ padding: 20, fontWeight: 'bold', fontSize: 18 }}>{row.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Informações de Entrega */}
      <section style={{ padding: '64px 16px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 32 }}>
            ⚡ INFORMAÇÕES DE ENTREGA
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: 24
          }}>
            {[
              { icon: '🚀', title: 'Como Funciona', items: ['1. Escolha seu pacote', '2. Entre em contato via WhatsApp', '3. Realize o pagamento', '4. Receba seus créditos!'] },

              { icon: '📝', title: 'Como Solicitar', items: ['1. Escolha seu pacote', '2. Clique em "Comprar Agora"', '3. Envie o comprovante via WhatsApp', '4. Receba seus créditos!'] },
              { icon: '🎁', title: 'O Que Você Recebe', items: ['✨ Seus créditos na conta', '💰 Melhor preço do mercado', '🛡️ Garantia de entrega', '💬 Suporte prioritário'] }
            ].map((card, i) => (
              <div key={i} style={{
                background: 'hsl(217, 33%, 20%)',
                padding: 32,
                borderRadius: 12,
                border: '2px solid rgba(139,92,246,0.3)'
              }}>
                <h3 style={{ fontSize: 22, marginBottom: 16, color: 'hsl(263, 70%, 63%)' }}>
                  {card.icon} {card.title}
                </h3>
                {card.items.map((item, j) => (
                  <p key={j} style={{ marginBottom: 6, fontSize: 15 }}>{item}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quem Somos */}
      <section style={{
        background: 'linear-gradient(180deg, hsl(217, 33%, 17%), hsl(217, 33%, 22%))',
        padding: '64px 16px'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 40 }}>
            👥 QUEM SOMOS
          </h2>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 48,
            flexWrap: 'wrap'
          }}>
            <div style={{ flex: 1, minWidth: 280 }}>
              <img
                src="https://static.lumi.new/20/2060299bbd3e43532341649d9d9976c5.webp"
                alt="Mestre do Lovable"
                style={{ width: '100%', borderRadius: 16, border: '3px solid hsl(263, 70%, 63%)' }}
              />
            </div>
            <div style={{ flex: 1, minWidth: 280 }}>
              <h3 style={{ fontSize: 30, marginBottom: 8, color: 'hsl(263, 70%, 63%)' }}>
                Comunidade Mestre do Lovable
              </h3>
              <p style={{ fontSize: 16, marginBottom: 24, color: 'hsl(263, 70%, 63%)' }}>
                Especialista em Lovable
              </p>
              <p style={{ fontSize: 17, marginBottom: 24 }}>
                Com anos de experiência em desenvolvimento no-code e IA, nos tornamos referência na comunidade brasileira de Lovable.
              </p>

              {[
                { emoji: '📖', title: 'Criador da Bíblia do Lovable', desc: 'O guia definitivo com todas as melhores práticas e técnicas avançadas da plataforma' },
                { emoji: '📺', title: 'Canal Mestre do Lovable', desc: 'Tutoriais, hacks e estratégias exclusivas para dominar o vibe coding' },
                { emoji: '👥', title: 'Comunidade com +2000 Membros Ativos', desc: 'Líder da maior comunidade brasileira de Lovable no WhatsApp' },
                { emoji: '🛡️', title: 'Serviço Confiável e Profissional', desc: 'Centenas de clientes satisfeitos com total segurança e transparência' }
              ].map((item, i) => (
                <div key={i} style={{ marginBottom: 16 }}>
                  <p style={{ fontSize: 17, marginBottom: 6 }}>
                    {item.emoji} <strong>{item.title}</strong>
                  </p>
                  <p style={{ fontSize: 15, color: 'hsl(215, 20%, 75%)', marginLeft: 28 }}>
                    {item.desc}
                  </p>
                </div>
              ))}

              <div style={{
                background: 'rgba(147, 112, 219, 0.2)',
                borderLeft: '4px solid hsl(263, 70%, 63%)',
                padding: 16,
                borderRadius: 8,
                marginTop: 24
              }}>
                <p style={{ fontSize: 15, fontStyle: 'italic', color: 'hsl(215, 20%, 85%)' }}>
                  "Minha missão é democratizar o acesso à criação de aplicações com IA, tornando a tecnologia acessível para todos."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Por Que Comprar */}
      <section style={{ padding: '64px 16px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 32 }}>
            ⭐ POR QUE COMPRAR DE MIM?
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: 24
          }}>
            {[
              { icon: '💎', title: 'Preço Justo', desc: 'Os melhores preços do mercado para créditos Lovable.' },
              { icon: '⚡', title: 'Processo Simples', desc: 'Atendimento personalizado com suporte dedicado para todas as suas dúvidas.' },
              { icon: '💬', title: 'Suporte Total', desc: 'Atendimento dedicado antes, durante e depois da sua compra.' }
            ].map((card, i) => (
              <div key={i} style={{
                background: 'hsl(217, 33%, 20%)',
                padding: 32,
                borderRadius: 12,
                border: '2px solid rgba(139,92,246,0.3)'
              }}>
                <h3 style={{ fontSize: 22, marginBottom: 16, color: 'hsl(263, 70%, 63%)' }}>
                  {card.icon} {card.title}
                </h3>
                <p style={{ fontSize: 15 }}>{card.desc}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <p style={{ fontSize: 17, marginBottom: 16 }}>
              🎬 Confira nosso canal no YouTube com tutoriais e dicas:
            </p>
            <a
              href="https://www.youtube.com/@MESTREDOLOVABLE"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'hsl(0, 84%, 60%)', textDecoration: 'none', fontSize: 20, fontWeight: 'bold' }}
            >
              📺 @MESTREDOLOVABLE
            </a>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section style={{
        background: 'linear-gradient(180deg, hsl(217, 33%, 17%), hsl(217, 33%, 22%))',
        padding: '64px 16px'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 12 }}>
            📱 DEPOIMENTOS REAIS
          </h2>
          <p style={{ textAlign: 'center', fontSize: 17, color: 'hsl(215, 20%, 65%)', marginBottom: 36 }}>
            Veja o que nossos clientes dizem sobre nós
          </p>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
            gap: 20
          }}>
            {testimonials.map((img, i) => (
              <div key={i} style={{
                borderRadius: 14,
                border: '2px solid rgba(139,92,246,0.3)',
                overflow: 'hidden',
                transition: 'all 0.3s',
                cursor: 'pointer'
              }}>
                <img src={img} alt={`Depoimento ${i + 1}`} loading="lazy" style={{ width: '100%', height: 'auto', display: 'block' }} />
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 36 }}>
            <p style={{ color: 'hsl(142, 71%, 45%)', fontSize: 22, fontWeight: 'bold' }}>
              ✅ Mais de 1000+ Clientes Satisfeitos
            </p>
          </div>
        </div>
      </section>

      {/* Pacotes em Destaque */}
      <section style={{ padding: '64px 16px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 'bold', textAlign: 'center', marginBottom: 12 }}>
            🎁 PACOTES EM DESTAQUE
          </h2>
          <p style={{ textAlign: 'center', fontSize: 17, color: 'hsl(215, 20%, 65%)', marginBottom: 40 }}>
            Escolha o pacote ideal para suas necessidades
          </p>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
            gap: 28
          }}>
            {packages.map((pkg, i) => (
              <div key={i} style={{
                background: pkg.color,
                padding: 32,
                borderRadius: 16,
                border: '2px solid rgba(255,255,255,0.2)',
                textAlign: 'center',
                transition: 'all 0.3s',
                position: 'relative'
              }}>
                {pkg.featured && (
                  <span style={{
                    position: 'absolute',
                    top: -12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'hsl(43, 96%, 56%)',
                    color: 'hsl(217, 33%, 17%)',
                    padding: '6px 16px',
                    borderRadius: 20,
                    fontSize: 12,
                    fontWeight: 'bold'
                  }}>
                    DESTAQUE
                  </span>
                )}
                <p style={{ fontSize: 13, fontWeight: 600, opacity: 0.9, marginBottom: 8 }}>{pkg.name}</p>
                <p style={{ fontSize: 46, fontWeight: 'bold', marginBottom: 6 }}>{pkg.credits}</p>
                <p style={{ fontSize: 13, opacity: 0.9 }}>CRÉDITOS</p>
                <p style={{ fontSize: 30, fontWeight: 'bold', margin: '20px 0 24px' }}>{pkg.price}</p>
                <a
                  href={`${whatsappBase}${encodeURIComponent(pkg.whatsapp)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: 'hsl(142, 71%, 45%)',
                    color: '#fff',
                    padding: '14px 28px',
                    border: 'none',
                    borderRadius: 12,
                    fontSize: 16,
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    display: 'inline-block',
                    transition: 'all 0.3s',
                    width: '100%'
                  }}
                >
                  💬 COMPRAR AGORA
                </a>
              </div>
            ))}
          </div>
          <p style={{ textAlign: 'center', marginTop: 32, fontSize: 15, color: 'hsl(215, 20%, 65%)' }}>
            💳 Aceitamos: PIX • Cartão de Crédito • Transferência Bancária
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section style={{
        padding: '80px 16px',
        background: 'linear-gradient(135deg, hsl(220, 70%, 12%), hsl(220, 60%, 8%))'
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(28px, 5vw, 40px)',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: 12,
            background: 'linear-gradient(135deg, hsl(220, 100%, 70%), hsl(280, 100%, 75%))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            Perguntas Frequentes
          </h2>
          <p style={{ textAlign: 'center', color: 'hsl(215, 20%, 65%)', marginBottom: 36, fontSize: 16 }}>
            Tire suas dúvidas antes de garantir seus créditos
          </p>
          <div style={{
            background: 'hsl(220, 70%, 15%)',
            borderRadius: 16,
            overflow: 'hidden',
            border: '1px solid hsl(220, 60%, 20%)'
          }}>
            {faqItems.map((faq, i) => (
              <details key={i} style={{ borderBottom: i < faqItems.length - 1 ? '1px solid hsl(220, 60%, 20%)' : 'none' }}>
                <summary style={{
                  padding: '20px 24px',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 15,
                  listStyle: 'none',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  transition: 'background 0.3s ease'
                }}>
                  <span>{faq.question}</span>
                  <span style={{ fontSize: 22, lineHeight: 1, flexShrink: 0, marginLeft: 12 }}>›</span>
                </summary>
                <div style={{ padding: '0 24px 20px', color: 'hsl(215, 20%, 75%)', lineHeight: 1.7, fontSize: 14.5 }}>
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        background: 'hsl(217, 33%, 15%)',
        padding: '32px 16px',
        textAlign: 'center',
        color: 'hsl(215, 20%, 65%)'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <p>&copy; 2026 Créditos Lovable - Todos os direitos reservados</p>
          <p style={{ marginTop: 8 }}>
            📱 WhatsApp:{' '}
            <a href="https://wa.me/5511964768245" target="_blank" rel="noopener noreferrer" style={{ color: 'hsl(142, 71%, 45%)', textDecoration: 'none' }}>
              +55 11 96476-8245
            </a>
          </p>
          <p style={{ marginTop: 16, fontSize: 13 }}>
            Suporte dedicado • 100% Seguro
          </p>
          <div style={{ marginTop: 16 }}>
            <Link to="/produtos" style={{ color: 'hsl(215, 20%, 65%)', textDecoration: 'none', fontSize: 13, marginRight: 16 }}>
              Todos os Produtos
            </Link>
            <Link to="/privacy" style={{ color: 'hsl(215, 20%, 65%)', textDecoration: 'none', fontSize: 13 }}>
              Política de Privacidade
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Credits;
